import { MeetingRoom, MeetingRoomHighlightingState, MeetingSession, MeetingSessionHighlightingState } from "@kalyzee/kast-web-sdk/websocket";
import { isExpert } from "./roles";

export const isBoardSession = (session: MeetingSession, rooms?: MeetingRoom[]) => {
  return !!(isExpert(session.role)
    || session.highlighting === MeetingSessionHighlightingState.ONGOING
    || rooms?.some(r => 
      r.highlighting === MeetingRoomHighlightingState.ONGOING 
      && r.enlistedUserIds?.includes(session.user?.id ?? "")
    ));
};
